{
  "recordNumber": "331050167",
  "firstName": "T-Doug",
  "lastName": "T-Christensen",
  "fullcode": "MG8402M",
  "committeeCode": "MG84",
  "dealerCode": "02",
  "positionCode": "STAFF",
  "consultant": "T-jpenn@nada.org",
  "isManager": false,
  "additionalLinks": [
    {
      "name": "NADA Analytics",
      "url": "https://n-test.nada.org/vistadashlogin"
    },
    {
      "name": "Slide Guide",
      "url": "https://slideguide.nada.org/"
    },
    {
      "name": "20 Group Live",
      "url": "https://n-test.nada.org/20-group-live/login"
    },
    {
      "name": "Dealership Workforce Study",
      "url": "https://www.nadaworkforcestudy.com/sso.aspx?memberid=331050167&email=T-dchristensen@beardmorechevy.com"
    },
    {
      "name": "NADA Education",
      "url": "https://n-test.nada.org/nada/education-consulting"
    }
  ],
  "email": "T-dchristensen@beardmorechevy.com",
  "sentAt": "2025-08-05 07:38:31",
  "iat": 1754379511,
  "exp": 1754390111,
  "user": {
    "sub": "auth0|331209017",
    "email": "t-samera@lugofftoyota.com",
    "name": "t-samera@lugofftoyota.com",
    "committees": [
      {
        "categoryCode": "TWNNATL",
        "categoryName": "20 Group National",
        "code": "AM01",
        "codeCommittee": "DLR",
        "dealerCode": "01",
        "fullcode": "AM0101",
        "position": "STAFF",
        "positionCode": "STAFF"
      },
      {
        "categoryCode": "TWNNATL",
        "categoryName": "20 Group National",
        "code": "IT01",
        "codeCommittee": "DLR",
        "dealerCode": "02",
        "fullcode": "IT01",
        "position": "STAFF",
        "positionCode": "STAFF"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "02",
        "fullcode": "MG8402M",
        "position": "General Manager (Full Access)",
        "positionCode": "OFM"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "03",
        "fullcode": "MG8403M",
        "position": "General Manager (Full Access)",
        "positionCode": "GNM3"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "04",
        "fullcode": "MG8404M",
        "position": "General Manager (Full Access)",
        "positionCode": "GNM4"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "05",
        "fullcode": "MG8405M",
        "position": "General Manager (Full Access)",
        "positionCode": "GNM5"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "06",
        "fullcode": "MG8406M",
        "position": "General Manager (Full Access)",
        "positionCode": "GNM6"
      },
      {
        "categoryCode": "TWNIMR",
        "categoryName": "20 Group IMR",
        "code": "MG84",
        "codeCommittee": "MG84",
        "dealerCode": "01",
        "fullcode": "MG8401",
        "position": "Twenty Group Dealer",
        "positionCode": "DLR"
      }
    ]
  }
}
